import type { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { useLocation, useRoute } from 'preact-iso';
import { useRequest } from '@ox/blox';
import { visitFormsApi } from '@ox/visits-ui/clients/mtx';

export const VisitFormRedirectPage: FunctionalComponent = () => {
  const { route } = useLocation();
  const { params } = useRoute();
  const { request } = useRequest({
    context: visitFormsApi,
    method: visitFormsApi.getFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGet,
  });

  useEffect(() => {
    const fetchVisitFormLink = async () => {
      try {
        const results = await request({ visitFormId: params.visitFormId });
        if (results?.data?.formLink) {
          // Use window.location.href for a full page reload to ensure AuthContext reinitializes
          window.location.href = results.data.formLink;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching visit form link:', error);
        route('/');
      }
    };

    fetchVisitFormLink();
  }, [request, params.visitFormId, route]);

  return (
    <div className="container" style={{ textAlign: 'center', marginTop: '100px' }}>
      <p>Loading your visit form...</p>
    </div>
  );
};
